<template>
  <div class="yzx-version-comparison" id="comparison">
    <div class="img-box" @click="buyClick">
      <img
        class="mobile-img"
        src="@/assets/images/yzxBuyEntrance/app_equity.png"
        alt="版本权益对比"
      />
      <img
        class="pc-img"
        src="@/assets/images/yzxBuyEntrance/pc_equity.png"
        alt="版本权益对比"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'comparison',
  data() {
    return {}
  },

  methods: {
    buyClick() {
      window.open('http://zxcerp.djcps.com/')
    }
  }
}
</script>

<style lang="scss" scoped>
.yzx-version-comparison {
  background: #fff;
  .img-box {
    width: 100%;
    cursor: pointer;
    .mobile-img {
      display: block;
      width: 100%;
      height: auto;
    }

    .pc-img {
      display: none;
      width: 100%;
      height: auto;
    }
  }
}

/* PC端：显示PC图片 */
@media (min-width: 961px) {
  .yzx-version-comparison {
    .img-box {
      .mobile-img {
        display: none;
      }
      .pc-img {
        display: block;
      }
    }
  }
}
</style>
